import { createFileRoute } from "@tanstack/react-router";

import { LineSidebar } from "@/components/ManageLines/LineDetailSidebar";

const Component = () => {
  const { lineUuid } = Route.useParams();
  return <LineSidebar uuid={lineUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/settings/lines/$lineUuid")({
  component: Component,
});
